// extracted by mini-css-extract-plugin
export default {"container":"profile_container__v4PYg","profile":"profile_profile__P55g9","gender":"profile_gender__ki4ii","back":"profile_back__9APJ-","form":"profile_form__7SiO8"};